import { differenceInDays, parseISO, startOfDay } from 'date-fns';

import { getTitleData } from './getTitleData';

import type { GroupedTopics } from './types';
import type { Topic } from 'applications/GSP/pages/ParentHelper/types';

export const groupTopicsByDate = (topics: Topic[]) => {
  const today = startOfDay(new Date());

  const groupedTopics = topics.reduce<GroupedTopics>((acc, topic) => {
    const lastUpdateDate = startOfDay(parseISO(topic.lastUpdatedDate));
    const diffInDays = differenceInDays(today, lastUpdateDate);

    const { title, titleKey } = getTitleData(diffInDays, topic.isFavorite);

    if (!acc[title]) {
      acc[title] = { titleKey, topics: [] };
    }

    acc[title].topics.push(topic);

    return acc;
  }, {});

  return Object.entries(groupedTopics).map(([title, { topics, titleKey }]) => ({
    title,
    topics,
    titleKey,
  }));
};
